/* eslint-disable import/first */

import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://943327673433492af36797e11596ddfa@o4508966014877696.ingest.de.sentry.io/4508966016516176",
});

import "react-app-polyfill/ie9";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import AuthContext, { AuthContextType } from "./AuthContext";
import { Blowfish } from "javascript-blowfish";
import { LanguageContext } from "./LanguageContext";
import { Router } from "./views/Router";
import { Language, getLanguageForHostname } from "consumerhouse-shared";
import { RegisterFriendContext } from "./RegisterFriendContext";
import { StatusContext } from "./StatusContext";
import { GlobalClientSettings } from "consumerhouse-shared";
import ReactGA from "react-ga";
import { ConsumerHouseClient } from "./api";
import { createRoot } from "react-dom/client";

var bf = new Blowfish("Voor je kan meedoen, moet je inloggen of een account aanmaken.");

function Application() {
    ReactGA.initialize("UA-91319544-2"); // , {gaOptions: {siteSpeedSampleRate: 100}}

    const query = new URLSearchParams(window.location.search);

    const [auth, setAuth] = useState<AuthContextType | null>(() => {
        let saved = null;
        let local = localStorage.getItem("ch");
        if (local) {
            try {
                saved = JSON.parse(bf.trimZeros(bf.decrypt(local))) as AuthContextType;
            } catch (ex) {
                console.warn("[index] (warning) could not parse stored auth info:", ex);
            }
        }
        return saved;
    });
    const client = new ConsumerHouseClient(auth);
    client.onAuth = setAuth;

    useEffect(() => {
        if (auth) {
            localStorage.setItem("ch", bf.encrypt(JSON.stringify(auth)));
            ReactGA.set({
                userId: auth.user.id,
            });
        } else {
            localStorage.removeItem("ch");
        }
    }, [auth]);

    const [language, setLanguage] = useState<Language>(() => getLanguageForHostname(window.location.hostname));

    const [status, setStatus] = useState<GlobalClientSettings | null>(null);

    useEffect(() => {
        async function fetchStatus() {
            try {
                let res = await client.fetch("/status");

                setStatus((status) => {
                    if (JSON.stringify(status) !== JSON.stringify(res.settings)) return res.settings;
                    return status;
                });
            } catch (ex) {
                console.warn("Could not fetch status", ex);
            }
        }

        fetchStatus();
        let id = setInterval(fetchStatus, 30000);
        return () => clearInterval(id);
    }, []);

    return (
        <StatusContext.Provider value={status}>
            <RegisterFriendContext.Provider value={query.has("f") ? parseInt(query.get("f")!) / 1244 : null}>
                <LanguageContext.Provider value={{ language, setLanguage }}>
                    <AuthContext.Provider value={{ auth, setAuth, client }}>
                        <Router />
                    </AuthContext.Provider>
                </LanguageContext.Provider>
            </RegisterFriendContext.Provider>
        </StatusContext.Provider>
    );
}

const root = createRoot(document.getElementById("root")!);

root.render(
    <React.StrictMode>
        <Application />
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
